/* eslint-disable no-console */
import './App.css';

import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from '../components/errorBoundary/ErrorBoundary';
import Routes from '../routing/Routes';
import AppProviders from './AppProviders';
import AppInitializer from './AppInitializer';
import AppLayout from './AppLayout';
import config from '../core/context/config/config';

const baseName =
  window.location.href.indexOf('localhost') > -1 ? '/' : config.baseName;

function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <AppInitializer>
          <AppLayout>
            <Router basename={baseName}>
              <Routes />
            </Router>
          </AppLayout>
        </AppInitializer>
      </AppProviders>
    </ErrorBoundary>
  );
}

export default App;
